import { Button, Group, Paper, Title } from '@mantine/core';
import { IconPrinter } from '@tabler/icons-react';
import { IME_APLIKACIJE } from '../ime';
import { TemnoOzadje } from '../postavitev/TemnoOzadje';
import { NazajNaPrijavo } from '../registracija/vstop';
import { BesediloPogojev } from './BesediloPogojev';

/** Splošni pogoji kot samostojna stran ({@code /splosni-pogoji}), dostopna tudi brez prijave (registracija). */
export function SplosniPogojiStran() {
  return (
    <TemnoOzadje sirina={820}>
      <Paper radius="lg" p={{ base: 20, sm: 40 }} shadow="xl">
        <Group justify="space-between" align="flex-start" mb="sm" wrap="nowrap">
          <Title order={1} size="h3">
            Splošni pogoji uporabe aplikacije {IME_APLIKACIJE}
          </Title>
          <Button
            variant="subtle"
            size="compact-sm"
            leftSection={<IconPrinter size={16} />}
            onClick={() => window.print()}
            visibleFrom="sm"
          >
            Natisni
          </Button>
        </Group>
        <BesediloPogojev />
        <Group justify="center" mt="lg">
          <NazajNaPrijavo besedilo={`Na ${IME_APLIKACIJE}`} />
        </Group>
      </Paper>
    </TemnoOzadje>
  );
}
